import styled from "styled-components";

const StyledFooter = styled.footer`
  padding: 3rem;
  background: black;
  color: white;
  text-align: center;
`;

export default StyledFooter;
